import { Paper } from "@mui/material";
import SearchInput from "./SearchInput";

const BaseSearchBar = ({ searchValue, handleSearchValueChange, handleSearch }) => {

    const onSubmitHandler = (event, result) => {
        if (event) { event.preventDefault() }
        handleSearch(result)
    }

    const onSeachValueChangeHandler = (event) => {        
        handleSearchValueChange(event.target.value)
    }

    return (
        <Paper
            component="form"
            onSubmit={onSubmitHandler}
            sx={{ flex: 1 }}
        >
            <SearchInput
                params={{ fullWidth: true, autoFocus: true, InputProps: { value: searchValue, onChange: onSeachValueChangeHandler, placeholder: "Search here" } }}
                highlightedResult={searchValue}
                onSubmitHandler={handleSearch}
            />
        </Paper>
    );
};

export default BaseSearchBar;